// Vendor
import $ from 'jquery';

// Elements
let $el = $('.accordian-component');

class Accordian {
	constructor(el) {

		// Tab window transition duration (ms)
		this.transitionDuration = 500;

		// Classes
		this.activeClass = 'is-open';

		// Elements
		this.$el = $(el);
		this.$accordianToggles = this.$el.find('.accordian-toggle');
		this.nested = this.$el.data('nested');

		this.attachEvents();
	}

	attachEvents() {

		this.$accordianToggles.on('click', (evt) => {
			let accordianToggleBtn = $(evt.currentTarget);

			if(this.nested) {

				let accordianExpand = accordianToggleBtn.children('.accordian-expand');
				this.toggleAccordianSection(accordianToggleBtn, accordianExpand);
			} else {

				let accordianExpand = accordianToggleBtn.next('.accordian-expand');
				this.toggleAccordianSection(accordianToggleBtn, accordianExpand);
			}
		});

	}

	toggleAccordianSection(btn, content) {

		if ( !btn.hasClass(this.activeClass) ) {
			//open
			btn.addClass(this.activeClass);
			content.addClass(this.activeClass);
			content.slideDown();
		} else {
			//close
			btn.removeClass(this.activeClass);
			content.removeClass(this.activeClass);
			content.slideUp();
		}

	}
}

export default Accordian;

const _init = () => {
	if ($el.length) {
		//TODO iterate and init on each found element?
		new Accordian($el);
	}
};

_init();
